class CustomPopup {
  static chnPop(path) {
    const container = getDom(".legal-popup");
    const popupContent = getDom(".legal-popup-content");
    const doneBtn = getDom(".legal-popup-footer .btn-done");

    if (doneBtn) {
      const lngTxt = getLngTxt("button.done");

      if (lngTxt) {
        doneBtn.innerHTML = lngTxt;
      }

      doneBtn.onclick = function() {
        container.style.display = "none";

        root.classList.remove("locked");
        // clean content when closing...
        while (popupContent.firstChild) {
          popupContent.removeChild(popupContent.firstChild);
        }
      };

      popupContent.classList.add("with-footer");
    }
    else {
      const closeBtn = getDom(".legal-popup .btn-close");
      const backBtn = getDom(".legal-popup .btn-back");

      closeBtn.onclick = function() {
        container.style.display = "none";
      };

      backBtn.onclick = function() {
        container.style.display = "none";

        root.classList.remove("locked");
        // clean content when closing...
        while (popupContent.firstChild) {
          popupContent.removeChild(popupContent.firstChild);
        }
      };

      popupContent.classList.add("with-header");
    }

    const root = document.documentElement;
    root.classList.add("locked");

    let fetchPath = path;
    if (fetchPath.indexOf("https://") == -1)
      fetchPath = "https://s3.amazonaws.com/legal-docs.healthnote.co/clients" + path;

    var xhr = new XMLHttpRequest();
    xhr.open('GET', fetchPath);

    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        var status = xhr.status;
        if (status === 200) {
          var text = xhr.responseText;
          if (!text) return;
          popupContent.innerHTML = text;
          setTimeout(() => {
            container.scrollTop = 0;
          }, 100);
          container.style.display = "block";
        } else {
          alert("Cannot find data requested... Try again later");
          return null;
        }
      }
    }

    xhr.send();
  }

  static confirmPop(message, callback) {
    const container = getDom(".confirmation-popup");
    const popupContent = getDom(".confirmation-popup-content");
    const popupTitle = getDom(".confirmation-popup-title");

    popupTitle.innerHTML = message.title;
    popupContent.innerHTML = message.content;
    container.style.display = "block";
    container.callback = callback;

    const cancelBtn = getDom(".confirmation-popup .btn-cancel");
          cancelBtn.innerHTML = getLngTxt("button.cancel");
    const okkBtn = getDom(".confirmation-popup .btn-ok");
          okkBtn.innerHTML = getLngTxt("button.ok");
          
    cancelBtn.onclick = function() {
      container.style.display = "none";
      container.callback(false);
    };

    okkBtn.onclick = function() {
      container.style.display = "none";
      container.callback(true);
    };
  }
}

module.exports = CustomPopup;
